import React from "react";
import { Router, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import PrivateRoute from "./PrivateRoute/PrivateRoute";
import PublicRoute from "./PublicRoute/PublicRoute";
import LoginRoute from "./LoginRoute/LoginRoute";
import OrganizationHome from "../Pages/Roles/Organization/OrganizationHome";
import CommonUnAuth from "../Pages/UnAuth/CommonUnAuth";
import ManageInfo from "../Pages/Roles/Organization/ManageInfo/MI/index";
import ComponentList from "../Components/ComponentList";
import Dashboard from "../Pages/Auth/Dashboard";
import OrganisationCreate from "../Pages/Roles/Admin/Organisation/Create";
import OnboardingPartnerAdmin from "../Pages/Roles/Admin/Partner/OnboardingPartnerAdmin";
import OnboardingPartner from "../Pages/Roles/Partner/OnboardingPartner";
import EmployeeCreate from "../Pages/Roles/Admin/Employee/Create";
import CustomUploadFiles from "../Components/CustomUploadFiles";
import AssignmentDetail from "../Pages/Roles/Organization/ManageInfo/AssignmentDetail";
import AssignmentSummary from "../Pages/Roles/Organization/ManageInfo/AssignmentSummary";
import PartnerList from "../Pages/Roles/Partner/PartnerList";
import OrganisationList from "../Pages/Roles/Admin/Organisation/List/index";
import EmployeeView from "../Pages/Roles/Admin/Employee/EmployeeView/index";
import EmployeeList from "../Pages/Roles/Admin/Employee/List/index";
import CoachList from "../Pages/Roles/Coach/ExternalCoach/CoachList";
import CoachSearch from "../Pages/Roles/Coach/ExternalCoach/CoachSearch";
import CombineSearch from "../Pages/Roles/Coach/CombineSearch";
import CoachDetail from "../Pages/Roles/Coach/Shared/CoachDetail";
import InternalCoachList from "../Pages/Roles/Coach/InternalCoach/InternalCoachList";
import InternalCoachSearch from "../Pages/Roles/Coach/InternalCoach/InternalCoachSearch";
import CoachHome from "../Pages/Roles/Coach/Coach_Home";
import AdminHome from "../Pages/Roles/Admin/AdminHome";
import FinanceAdminHome from "../Pages/Roles/FinanceAdmin/FinanceAdminHome";
import InvoiceDetails from "../Pages/Roles/FinanceAdmin/InvoiceDetails";
import Setup from "../Pages/Roles/Admin/Setup/index";
import Reports from "../Pages/Roles/Admin/Reports";
import Crf from "../Pages/Roles/Admin/Crf";
import Profile from "../Pages/Roles/Admin/Profile";
import CoachingRequestForm from "../Pages/Roles/Crf";
import CoachingRequestFormEmail from "../Pages/Roles/CrfEmail";
import CoachDetailEmail from "../Pages/Roles/Admin/Employee/coachDetail";

import AdminDashboard from "../../src/Pages/Roles/Organization/ManageInfo/Dashboard/index";
import EvaluationForm from "../Pages/Roles/EvaluationForm";
import PartnerReferenceQas from "../Pages/Roles/partner_reference_qas";
import CoachingAgreementtForm from "../Pages/Roles/Caf";
import CRFAcknowledgementForm from "../Pages/Acknowledgement/AcknowledgeForm";
import OtherOrgUserLoginPage from "../Pages/Acknowledgement/OtherOrgUserLoginPage";
import CAFacknowledge from "../Pages/Acknowledgement/CAFacknowledge";
import EvaluationAcknowledge from "../Pages/Acknowledgement/EvaluationAcknowledge";
import partnerAcknowledge from "../Pages/Acknowledgement/partnerReferenceAck";
import FilterMI from "../Pages/Home/FilterMI";
import LiveView from "../Pages/Roles/Admin/Organisation/LiveView";
/**
 * Creat browser history stack
 */
export const history = createBrowserHistory();

const AdminRoutes = () => {
  return (
    <Switch>
      <PrivateRoute exact path="/admin/crf" component={Crf} />
      <PrivateRoute
        exact
        path="/admin/organisation/:id/employee/:employeeid/edit"
      >
        <EmployeeCreate edit="yes" />
      </PrivateRoute>
      <PrivateRoute
        exact
        path="/admin/organisation/create"
        component={OrganisationCreate}
      />
      <PrivateRoute
        exact
        path="/admin/organisation/:id/employee/create"
        component={EmployeeCreate}
      />
      <PrivateRoute exact path="/admin/organisation/:id/edit">
        <OrganisationCreate edit="yes" />
      </PrivateRoute>
      <PrivateRoute
        exact
        path="/admin/organisation/:id/employee/list"
        component={EmployeeList}
      />
      <PrivateRoute
        exact
        path="/admin/organisation/profile"
        component={Profile}
      />
      <PrivateRoute exact path="/admin/partner/list" component={PartnerList} />
      <PrivateRoute
        exact
        path="/admin/organisation/list"
        component={OrganisationList}
      />
      <PrivateRoute exact path="/admin/liveView/:type" component={LiveView} />
      <PrivateRoute
        exact
        path="/admin/organisation/:id"
        component={EmployeeView}
      />
      <PrivateRoute
        exact
        path="/admin/partner/onboarding"
        component={OnboardingPartnerAdmin}
      />
      <PrivateRoute exact path="/admin/setup" component={Setup} />
      <PrivateRoute exact path="/admin/reports" component={Reports} />
      <PrivateRoute exact path="/admin/dashboard" component={AdminDashboard} />
    </Switch>
  );
};

const PartnerRoutes = () => {
  return (
    <Switch>
      <PrivateRoute
        exact
        path="/partner/onboarding"
        component={OnboardingPartner}
      />
      <PrivateRoute exact path="/partner" component={PartnerList} />
    </Switch>
  );
};

const FinanceRoutes = () => {
  return (
    <Switch>
      <PrivateRoute
        exact
        path="/FinanceAdminHome"
        component={FinanceAdminHome}
      />
      <PrivateRoute
        exact
        path="/FinanceAdminHome/invoiceDetails/:id"
        component={InvoiceDetails}
      />
    </Switch>
  );
};

/**
 * Register applications all routes here
 * @constructor
 */
const Routes = () => (
  <Router history={history}>
    <Switch>
      <LoginRoute exact path="/auth/:path" component={CommonUnAuth} />

      <PrivateRoute
        exact
        path="/OrganizationHome"
        component={OrganizationHome}
      />
      <PrivateRoute exact path="/ComponentList" component={ComponentList} />
      <PrivateRoute exact path="/dashboard" component={Dashboard} />
      <PrivateRoute
        exact
        path="/coaching_request_form/:slug"
        component={CoachingRequestForm}
      />
      <PublicRoute
        exact
        path="/partner_reference_qas/:slug"
        component={PartnerReferenceQas}
      />
      <PublicRoute
        exact
        path="/coaching_request_forms_email/:slug"
        component={CoachingRequestFormEmail}
      />
      <PrivateRoute
        exact
        path="/evaluation_form/:slug"
        component={EvaluationForm}
      />
      <PrivateRoute
        exact
        path="/coaching_agreement_form/:slug"
        component={CoachingAgreementtForm}
      />
      <PrivateRoute exact path="/custom" component={CustomUploadFiles} />
      <PrivateRoute exact path="/CombineSearch" component={CombineSearch} />
      <PrivateRoute exact path="/CoachDetail" component={CoachDetail} />
      <PublicRoute
        exact
        path="/coach_panels/view_external_coach_profile/"
        component={CoachDetailEmail}
      />
      <PrivateRoute exact path="/CoachSearch" component={CoachSearch} />
      <PrivateRoute exact path="/CoachHome" component={CoachHome} />
      <PrivateRoute exact path="/CoachList" component={CoachList} />
      <PrivateRoute
        exact
        path="/InternalCoachList"
        component={InternalCoachList}
      />
      <PrivateRoute
        exact
        path="/InternalCoachSearch"
        component={InternalCoachSearch}
      />

      <PrivateRoute exact path="/AdminHome" component={AdminHome} />
      <PrivateRoute
        exact
        path="/OrganizationHome"
        component={OrganizationHome}
      />
      <PrivateRoute
        exact
        path="/assignmentoverview"
        component={AssignmentDetail}
      />
      <PrivateRoute
        exact
        path="/assignmentsummary"
        component={AssignmentSummary}
      />
      <PrivateRoute
        exact
        path="/acknowledgement"
        component={CRFAcknowledgementForm}
      />
      <PrivateRoute
        exact
        path="/otheruserlogin"
        component={OtherOrgUserLoginPage}
      />
      <PrivateRoute
        exact
        path="/cafacknowledgement"
        component={CAFacknowledge}
      />
      <PrivateRoute
        exact
        path="/evaluationacknowledgement"
        component={EvaluationAcknowledge}
      />
      <PrivateRoute
        exact
        path="/partnercknowledgement"
        component={partnerAcknowledge}
      />
      <PrivateRoute exact path="/ManageInfo" component={ManageInfo} />
      <PrivateRoute exact path="/ManageInfo/Statistics" component={FilterMI} />
      <PrivateRoute exact path="/admin*" component={AdminRoutes} />

      <PrivateRoute exact path="/partner*" component={PartnerRoutes} />

      <PrivateRoute exact path="/FinanceAdminHome*" component={FinanceRoutes} />
      <LoginRoute exact path="/" component={CommonUnAuth} />
    </Switch>
  </Router>
);

export default Routes;
